import { lazy } from 'react';

export const ReportsPageSpendSummaryAsync = lazy(
    () => import('./ReportsPageSpendSummary'),
);
